export enum RankedBarTableSortDirection {
  ASC = "asc",
  DESC = "desc",
}

export interface RankedBarTableItem {
  rank: number
  name: string
  weight: number
  value: number
}
